<template>
    <div class="editor-hotspot" v-on:click="focus()">
        <div class="editor"></div>
    </div>
</template>

<script>
import * as ace from 'brace';
import 'brace/mode/latex';
import 'brace/theme/chrome';

export default {
    name: 'Editor',
    data: function(){
        return {
            editor: null
        }
    },
    props: {
        content: {
            type: String,
            twoWay: true,
            required: true
        },
        disabled: {
            type: Boolean,
            twoWay: false,
            required: false
        }
    },
    methods: {
        focus: function(){
            this.editor.focus();
        }
    },
    mounted: function(){
        this.editor = ace.edit(this.$el.children[0]);

        this.editor.$blockScrolling = Infinity;

        this.editor.getSession().setMode('ace/mode/latex');
        this.editor.getSession().setUseWrapMode(true);
        this.editor.setTheme('ace/theme/chrome');
        this.editor.setValue(this.content, 1);
        this.editor.setOption('minLines', 20);
        this.editor.setOption('maxLines', Infinity);
        this.editor.setAutoScrollEditorIntoView(true);
        this.editor.setShowPrintMargin(false);

        this.editor.on('change', () => {
            this.backup = this.editor.getValue();
            this.$emit('update:content', this.backup);
            this.$emit('change');
        });
    },
    watch: {
        content: function(){
            if(this.backup === this.content){
                return;
            }

            this.editor.setValue(this.content, 1);
        },
        disabled: function(){
            this.editor.setReadOnly(this.disabled);
        }
    }
}
</script>

<style lang="less">
    @import "../less/variables";
    @import "../less/mixins";

    .editor-hotspot
    {
        height: 100%;
        width: 100%;
        cursor: text;
        background: @f8;
    }

    .editor.ace-chrome
    {
        font-family: Inconsolata;
        font-size: 15px;
        font-weight: 700;
        line-height: 20px;
        background: @f8;

        .ace_gutter
        {
            background: @f8;
        }

        .ace_gutter-cell
        {
            // background: transparent;
            color: @grey;
        }

        .ace_gutter-active-line, .ace_active-line
        {
            // background: transparent;
            color: #555;
        }

        .ace_storage, .ace_keyword, .ace_meta.ace_tag
        {
            color: @blue;
        }

        .ace_comment, .ace_comment.ace_doc, .ace_comment.ace_doc.ace_tag
        {
            color: #888;
        }
    }
</style>